<script setup>
import { inject, ref, watch, defineExpose, defineProps, toRefs } from "vue"
import groupCom from "./../common/group.vue" //指标组信息
import swiperTab from "@/components/common/swiperTab.vue"; //指标组tab
import i18n from "@/i18n"
import { uploadFile } from "@/service"; //上传接口
const indicatorstandardsList = ref([]); // 指标list
import SwiperTool from "@/components/swiperTool.vue";
import { showMessage } from "@/utils/hooks/message"
import { getLangValue } from "@/utils/common"; //获取后端语言
const index_standards_list = inject('index_standards_list')
const activeIndex = ref(0) //当前高亮
const props = defineProps({
    groupList: {
        type: Object,
        required: true,
        default: () => ({})
    },
    p_id: {
        type: String,
        required: true,
        default: ''
    },
    company_list: {
        type: Array,
        required: true,
        default: () => [] //存储所有的检测机构
    }
})
const { groupList, p_id, company_list } = toRefs(props)
const groupList2 = ref([]) // 2级
const groupList3 = ref([]) // 3级
const shortcuts = [
    {
        text: getLangValue("base.permanent"),
        value: `9999-12-31`,
    },
];
// const current_hscode = inject("current_hscode")
// const detailInfo = inject('detailInfo')
// const openAlert = inject('openAlert')
const current_tab = ref('') // 1级
const current_tab1 = ref('') // 2级
const current_tab2 = ref('') // 3级
const onAddgroupindicator = () => {
    // add 指标  已废除
    let m = {
        name: '',
        value: '',
        unit: '',
        reference: '',
        isNewAdd: true
    }
    indicatorstandardsList.value[activeIndex.value].indicatorList.push(m)
}
const isCheckForm = ref(false) // 验证表单信息
const checkedList = ref([]) // 选中的list
const inputFileid = ref('') // 唯一标识
const formData = ref({
    testing_institution: '',
    qualification_of_testing_institution: '',
    certification_date: '', // 2024-9-2 新增字段
    validity_period_of_certification: '', // 2024-9-2 新增字段
    certification_body: '', // 2024-9-2 新增字段
    remark: '',
})
// const company_list = ref([])// 存储所有的检测机构
const company_name_list = ref([]) //筛选的检测机构
const loading = ref(false) //加载状态
const groupRef = ref(null)
const uploadFileList = ref([])
const onDeleteGroupindicator = (i) => {
    indicatorstandardsList.value[activeIndex.value].indicatorList.splice(i, 1)
}
const showDrop = ref(false) // 批量上传
const checkForm = () => {
    // 验证表单信息
    let checkRes = true;
    let checkStatus = 0
    isCheckForm.value = true;
    for (const item in index_standards_list.value) {
        const { indicatorList } = index_standards_list.value[item]
        // const arr = indicatorList.filter(item => item.isNewAdd)
        for (const item1 in indicatorList) {
            const { testing_institution, qualification_of_testing_institution } = indicatorList[item1]
            if (!testing_institution || !qualification_of_testing_institution) {
                checkRes = false;
                break;
            }
            // if (has_report == '是' && (!indicatorList[item1].fileList || indicatorList[item1].fileList.length == 0)) {
            //     // console.log('没有图片');
            //     checkStatus = 1
            //     checkRes = false;
            //     break;
            // }
        }
    }
    return { checkRes, checkStatus }
}


const onUpload = ({ index, file }) => {
    // 上传图片
    if (!index_standards_list.value[current_tab.value].indicatorList[index].extra || !index_standards_list.value[current_tab.value].indicatorList[index].extra.fileList) {
        index_standards_list.value[current_tab.value].indicatorList[index].extra = {
            fileList: []
        }
    }
    index_standards_list.value[current_tab.value].indicatorList[index].extra.fileList.push(file)
}

const onDeleteFile = ({ i, file_i }) => {
    // 删除图片
    index_standards_list.value[current_tab.value].indicatorList[i].extra.fileList.splice(file_i, 1)
}

const upload = () => {
    /**批量上传 */
    // console.log(indicatorstandardsList.value[activeIndex.value].indicatorList);
    // showModal.value = true
    checkedList.value = JSON.parse(JSON.stringify([...index_standards_list.value[current_tab.value].indicatorList.filter(item => item.checked)]))
    if (checkedList.value.length == 0) {
        // openAlert(
        //     {
        //         variant: "danger",
        //         content: i18n.global.t("product_template.requiredIndicato1"),
        //     }
        // );
        showMessage('danger', getLangValue("product-template.requiredIndicato1"))
        return false
    }
    document.getElementById('myBtn' + p_id.value).click()
    showDrop.value = true
    inputFileid.value = `file${new Date().getTime()}`
}

const batch_delete = () => {
    /**批量删除 */
    checkedList.value = JSON.parse(JSON.stringify([...index_standards_list.value[current_tab.value].indicatorList.filter(item => item.checked)]))
    if (checkedList.value.length == 0) {
        showMessage('danger', getLangValue("product-template.requiredIndicato1"))
        return false
    }
    checkedList.value.forEach(item => {
        index_standards_list.value[current_tab.value].indicatorList.forEach(iitem => {
            if (item.name === iitem.name) {
                iitem.value = ''
                iitem.checked = false
            }
        })
    })
}

const remoteMethod = async (query) => {
    /**远程搜索 */
    // console.log(query);
    if (query) {
        loading.value = true
        let arr = company_list.value.filter(item => item.company_name.includes(query) || item.company_name.includes(query.toLowerCase()) || item.company_name.includes(query.toUpperCase()))
        if (arr.length > 0) {
            company_name_list.value = [arr[0].company_name]
        } else {
            company_name_list.value = [query]
        }
        loading.value = false
    } else {
        company_name_list.value = []
    }
}

const changeCompany = () => {
    /**切换企业
     * 选择已有的检测机构把啊认证资质机构  认证有效期带出来
     */
    let index = company_list.value.findIndex(item => item.company_name == formData.value.testing_institution)
    if (index > -1) {
        // 设置信息
        formData.value.certification_body = company_list.value[index].company_qualification_certification_body
        formData.value.validity_period_of_certification = company_list.value[index].company_qualification_validity_period
    }
}


/**文件上传部分 */
const checkFile = (file) => {
    // 验证是否是图片或者PDF
    let name = /^device\//.test(file.name)
        ? file.name.substring(44)
        : file.name;
    let suffix = name.substring(name.lastIndexOf(".")).toLowerCase();
    const accept = '.png,.jpg,.jpeg,.pdf,.docx,.doc,.xlsx,.xls'
    if (!accept) return true
    // 判断是否属于指定的类型
    if (accept.indexOf(suffix) == -1) {
        showMessage('danger', getLangValue("upload.notCorrectType"))
        return false;
    }
    // 判断是否是同一个文件
    let arr = uploadFileList.value.filter(item => item.filname == name)
    if (arr.length > 0) {
        return false;
    }
    return true;
}
const selectedFile = () => {
    let idStr = '#' + inputFileid.value;
    let fileMaxSize = 1024 * 1024 * 50
    let dropzoneFile = document.querySelector(idStr).files[0];
    if (!dropzoneFile) return;

    if (dropzoneFile.size > fileMaxSize) {
        showMessage('danger', getLangValue("upload.limit") + '50M')
        // document.getElementById(idStr).value = "";
        return;
    }
    if (!checkFile(dropzoneFile)) {
        document.getElementById(idStr).value = "";
        return;
    }
    uploadFile(dropzoneFile)
        .then((res) => {
            uploadFileList.value.push(res.data.payload);
            document.querySelector(idStr).value = ''
        })
        .catch((e) => {
            console.log(e);
        });

}
const drop = (e) => {
    let dropzoneFile = e.dataTransfer.files[0];
    if (!dropzoneFile) return;
}
const deleteFile = (i) => {
    uploadFileList.value.splice(i, 1);
}

/**文件上传部分 */

const cancelFunction = () => {
    uploadFileList.value = []
    document.getElementById('myBtn' + p_id.value).click()
    showDrop.value = false
}

const okFunction = () => {
    isCheckForm.value = true
    /**验证 */
    /**去掉验证 需要再加上 */
    // if (!formData.value.testing_institution || !formData.value.qualification_of_testing_institution ||
    //     !formData.value.certification_date ||
    //     !formData.value.validity_period_of_certification ||
    //     !formData.value.certification_body
    // ) {
    //     showMessage('danger', getLangValue("base.requiredinformation"))
    //     return false
    // }
    // if (uploadFileList.value.length == 0) {
    //     showMessage('danger', getLangValue("upload.uploadedFile1"))
    //     return false
    // }

    // 同步数据
    checkedList.value.forEach(item => {
        index_standards_list.value[current_tab.value].indicatorList.forEach(iitem => {
            if (item.name === iitem.name) {
                iitem.value = item.value
                iitem.testing_institution = formData.value.testing_institution
                iitem.qualification_of_testing_institution = formData.value.qualification_of_testing_institution
                iitem.certification_date = formData.value.certification_date
                iitem.validity_period_of_certification = formData.value.validity_period_of_certification
                iitem.certification_body = formData.value.certification_body
                // iitem.fileList = [...uploadFileList.value]
                iitem.extra = {
                    fileList: [...uploadFileList.value]
                }
                iitem.checked = false
            }
        })
    })
    // 
    uploadFileList.value = []
    document.getElementById('myBtn' + p_id.value).click()
    groupRef.value.allcheck = false
    // document.getElementById("dropzoneFile").value = "";
}

const allcheckFun = (checkRes) => {
    // 全选
    index_standards_list.value[current_tab.value].indicatorList.forEach(iitem => {
        iitem.checked = checkRes
    })
}


const changTab = () => {
    // 根据current_tab 设置子集信息
    // console.log(current_tab.value);
    let arr = current_tab.value.split('_');
    if (arr.length == 2) {
        // 代表第一级  需要联动第二级  第三级
        // 第二级
        groupList2.value = groupList.value.groupList2.filter(item => item.id.includes(current_tab.value));
        // 第三级
        groupList3.value = groupList.value.groupList3.filter(item => item.id.includes(current_tab.value));
        current_tab1.value = ''
        current_tab2.value = ''
    } else if (arr.length == 3) {
        // 代表第二级  需要联动第三级
        // 第三级
        groupList3.value = groupList.value.groupList3.filter(item => item.id.includes(current_tab.value));
        current_tab2.value = ''
    }
}

watch(groupList, () => {
    // 设置一级信息 设置二级信息
    if (groupList.value.groupList2)
        groupList2.value = groupList.value.groupList2.filter(item => item.id.includes(p_id.value))
    if (groupList.value.groupList3)
        groupList3.value = groupList.value.groupList3.filter(item => item.id.includes(p_id.value))
    // 默认显示第一级数据
    current_tab.value = p_id.value
    // console.log(groupList);
}, { deep: true, immediate: true })

const onActiveTabId = (id) => {
    current_tab.value = id;
}

watch(current_tab, (_newVla, oldValue) => {
    // 清除全选
    if (groupRef.value != null) {
        groupRef.value.allcheck = false;
    }
    // 清除上一级选择
    index_standards_list.value[oldValue].indicatorList.forEach(iitem => {
        iitem.checked = false
    })
    changTab();

})
defineExpose({
    checkForm,
    indicatorstandardsList,
    current_tab
})
</script>
<template>
    <div class="ps-4">
        <swiperTab @onActiveTabId="onActiveTabId" :groupList="groupList2" v-model:current_tab="current_tab1"
            :tabKey="'group2'" :currentTabLang="i18n.global.locale == 'en' ? 2 : 1" />
    </div>
    <div class="ps-6">
        <swiperTab @onActiveTabId="onActiveTabId" :groupList="groupList3" v-model:current_tab="current_tab2"
            :tabKey="'group3'" :currentTabLang="i18n.global.locale == 'en' ? 2 : 1" />
    </div>
    <div v-if="index_standards_list[current_tab] && index_standards_list[current_tab].indicatorList.length">
        <div class="d-flex justify-content-end py-3 px-2" style="border-bottom: 1px solid #E9EBEC;">
            <button type="button" class="btn btn-success me-3" @click="upload()" style="min-width: 140px;">
                <i class="ri-add-fill me-1 align-bottom"></i>
                {{ getLangValue("product-management", "uploadMuti") }}
            </button>
            <button type="button" class="btn btn-danger me-3" @click="batch_delete()" style="min-width: 140px;">
                <i class="ri-delete-bin-line me-1 align-bottom"></i>
                {{ getLangValue("base", "batch_delete") }}
            </button>
        </div>
        <div class="card my-4">
            <!-- v-if="indicatorstandardsList[current_tab] && $route.query.type !== 'view'" -->
            <groupCom ref="groupRef" :isCheckForm="isCheckForm" :company_list='company_list'
                v-model:indicatorList="index_standards_list[current_tab].indicatorList"
                @onAddgroupindicator="onAddgroupindicator" @onDeleteGroupindicator="onDeleteGroupindicator"
                @onUpload="onUpload" @onDeleteFile="onDeleteFile" @allcheckFun="allcheckFun" />
        </div>
        <!-- 上传弹框 -->
        <!-- Default Modals -->
        <button type="button" class="btn btn-primary " data-bs-toggle="modal" :data-bs-target="'#myModal' + p_id"
            style="display: none;" :id="'myBtn' + p_id"></button>
        <div :id="'myModal' + p_id" class="modal fade" tabindex="-1" aria-labelledby="myModalLabel" aria-hidden="true"
            data-bs-backdrop="static">
            <div class="modal-dialog ">
                <div class="modal-content" style="width: 800px;">
                    <div class="modal-body">
                        <!-- 数据 -->
                        <div class="d-flex my-2">
                            <div style="flex:1">{{ getLangValue('hscode.indicatorName1') }}</div>
                            <div style="flex:1">{{ getLangValue('attribute.value') }}</div>
                        </div>
                        <div style="max-height: 200px; overflow-y: auto;">
                            <div class="d-flex my-2" v-for="(item, k) in checkedList" :key="k">
                                <div style="flex:1">{{ i18n.global.locale == 'en' ? item.name_en : item.name }}</div>
                                <div style="flex:1">
                                    <input v-model="item.value" class="form-control" @change="changeUnit" />
                                </div>
                            </div>
                        </div>
                        <div>
                            <div>
                                <label class="form-label">
                                    <span>{{ getLangValue('product-template.testingOrganization') }}</span>
                                    <!-- <span class="text-danger">*</span> -->
                                </label>
                            </div>
                            <!-- :class="[(isCheckForm && !formData.testing_institution) && 'is-invalid']" -->
                            <el-select style="width: 100%;height: 100%;" v-model="formData.testing_institution"
                                @change="changeCompany" filterable :loading="loading"
                                :remote-method="(query) => remoteMethod(query)" remote allow-create
                                :placeholder="getLangValue('product-management', 'message1')" size="large" clearable>
                                <el-option v-for="item1 in company_name_list" :key="item1.key" :label="item1"
                                    :value="item1">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="my-1">
                            <div>
                                <label class="form-label">
                                    <span>{{ getLangValue('product-template.testingOrganizationQualification') }}</span>
                                    <!-- <span class="text-danger">*</span> -->
                                </label>
                            </div>
                            <!-- :class="[(isCheckForm && !formData.qualification_of_testing_institution) && 'is-invalid']" -->
                            <input :placeholder="getLangValue('product-management', 'message2')"
                                v-model="formData.qualification_of_testing_institution" type="text" class="form-control"
                                required />
                        </div>
                        <div class="my-1">
                            <div>
                                <label class="form-label">
                                    <span>{{ getLangValue('product-template.testDate') }}</span>
                                    <!-- <span class="text-danger">*</span> -->
                                </label>
                            </div>
                            <!-- :class="[(isCheckForm && !formData.certification_date) && 'is-invalid']" -->
                            <el-date-picker :teleported="false" style="height: 37.5px; width: 100%;"
                                v-model="formData.certification_date"
                                :placeholder="getLangValue('product-management', 'message3')" size="large"
                                value-format="YYYY-MM-DD" />
                        </div>
                        <div class="my-1">
                            <div>
                                <label class="form-label">
                                    <span>{{ getLangValue('product-template.testinginstitutions') }}</span>
                                    <!-- <span class="text-danger">*</span> -->
                                </label>
                            </div>
                            <!-- :class="[(isCheckForm && !formData.validity_period_of_certification) && 'is-invalid']" -->
                            <el-date-picker :teleported="false" :shortcuts="shortcuts"
                                style="height: 37.5px; width: 100%;" v-model="formData.validity_period_of_certification"
                                :placeholder="getLangValue('my.account', 'form_test_date_placeholder1')" size="large"
                                value-format="YYYY-MM-DD" />
                        </div>
                        <div class="my-1">
                            <div>
                                <label class="form-label">
                                    <span>{{ getLangValue('product-template.testinginstitutions1') }}</span>
                                    <!-- <span class="text-danger">*</span> -->
                                </label>
                            </div>
                            <!-- :class="[(isCheckForm && !formData.certification_body) && 'is-invalid']" -->
                            <input :placeholder="getLangValue('product-management', 'message5')"
                                v-model="formData.certification_body" type="text" class="form-control" required />
                        </div>
                        <div>
                            <div>
                                <label class="form-label">
                                    <span>{{ getLangValue('product-template.report1') }}</span>
                                    <!-- <span class="text-danger">*</span> -->
                                </label>
                            </div>
                            <DropZone v-if="showDrop" :ipt-id="inputFileid"
                                accept=".png,.jpg,.jpeg,.pdf,.docx,.doc,.xlsx,.xls" @drop.prevent="drop"
                                @change.prevent="selectedFile" style="min-height: 220px"
                                :info="getLangValue('upload.type1')" />
                            <div class=" border-solid rounded p-1" v-show="uploadFileList && uploadFileList.length">
                                <div>
                                    <div class="border-primary fs-14 material-title">{{
                                        getLangValue("upload.uploadedFile") }}
                                    </div>
                                </div>
                                <div style="position: relative;" class="product-img-slide111r  ps-5 pe-5">
                                    <SwiperTool :swiperInfo="{
                                        type: 'image',
                                        page: 'assetform',
                                        spaceBetween: 10,
                                        slidesPerView: 6,
                                        actionsClass: [
                                            { name: 'ri-eye-fill', action: 'view' },
                                            { name: 'ri-download-2-fill', action: 'download' },
                                            { name: 'ri-delete-bin-5-fill', action: 'delete' },
                                        ],
                                    }" :list="uploadFileList" @deleteFile="deleteFile">
                                    </SwiperTool>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="cancelFunction" type="button" class="btn btn-light" data-bs-dismiss="modal">{{
                            getLangValue('base.cancel') }}</button>
                        <button @click="okFunction" type="button" class="btn btn-primary "
                            style="background-color: #0AB39C;border-color: unset;">{{ getLangValue('base.confirm')
                            }}</button>
                    </div>

                </div><!-- /.modal-content -->
            </div><!-- /.modal-dialog -->
        </div><!-- /.modal -->
    </div>
    <Empty v-else :content="getLangValue('base.no_indicator_data')" style="margin: 20px 0 !important;"></Empty>
</template>

<style scoped lang="scss">
.active {
    color: #0AB39C
}

:deep(.product-img-slide111r .swiper-slide) {
    min-width: 70px;
}

:deep(.product-img-slide111r .avatar-title) {
    min-width: 70px;
    justify-content: center;
}

:deep(.el-select__placeholder.is-transparent) {
    color: #888a98;
}

:deep(.is-invalid .el-input__wrapper) {
    border: 1px solid #f06548 !important;
}

:deep(.el-date-editor--date .el-input__inner) {
    color: #222529;
    font-size: 0.8125rem !important;
    &::placeholder {
        color: #878a99 !important;
    }
}

/* .el-date-editor .el-range-input {
    font-size: 0.8125rem !important;;
    color: #212529 !important;
    &::placeholder {
        color: #878a99 !important;
    }
} */
</style>